module.exports = __webpack_public_path__ + "media/Video 14.82bc80f3.mp4";